/*eslint eqeqeq: "off"*/
/*eslint no-unused-vars: "off"*/
/*eslint no-useless-escape: "off"*/


import React, { Component } from 'react'
import { Link } from 'react-router'
import NavBar from './../../ui/template/NavBar'
import SortableTree, { removeNodeAtPath, addNodeUnderParent } from 'react-sortable-tree';
import 'react-sortable-tree/style.css'; // This only needs to be imported once in your app
import firebase, { app } from '../../config/database'
import Config from '../../config/app';
import SectionConfig from '../../config/builder/sections_config';
import { Image } from '../../components/fields'
import Notification from '../../components/Notification';
import SkyLight from 'react-skylight';
import Wizzard from './../../ui/template/Wizzard';
import Input from '../../components/fields/Input'
import T from './../../translations/translate'
import { connect } from 'react-redux';
import HTML from '../../components/fields/HTML';
import update from 'react-addons-update'; // ES6

var _ = require('lodash');

import components from '../../config/builder/components'
const ConditionalDisplay = ({ condition, children }) => condition ? children : <div></div>;
const getNodeKey = ({ node }) => node.key;

class Venue extends Component {
  constructor(props) {
    super(props);

    this.state = {
      treeData: [],
      showAddButton: false,
      pathToDelete: "",
      nodeToDelete: { name: "" },
      inputDelete: "",
      md: SectionConfig.md,
      sv: SectionConfig.sv,
      canDeleteApp: false,
      updatetrack: false,
      updateinfobooth: false,
      selectedtrack: {},
      selectedtrackname: '',
      trackname: '',
      infoboothname: '',
      sectionsactive: ["active", "", ""],
      trackvalue: '',
      infoboothdes: '',
      infoboothlat: "",
      infoboothlong: "",
      infoboothadd: "",
      infoboothstate: "",
      infoboothcity: "",
      infoboothpin: "",
      infoboothcountry: "",
      infoboothemail: "",
      infoboothphone: "",
      infoboothwebsite: "",
      selectedinfobooth: {},
      selectedinfoboothname: '',
    };

    // this.processDataForShowing = this.processDataForShowing.bind(this);
    this.processDataForSaving = this.processDataForSaving.bind(this);
    this.appendSection = this.appendSection.bind(this);
    this.saveAppInfo = this.saveAppInfo.bind(this);
    this.cancelDelete = this.cancelDelete.bind(this);
    this.doDelete = this.doDelete.bind(this);
    this.appKey = "";
    this.confirmDeleteApp = this.confirmDeleteApp.bind(this);
    this.getAutoIncrementedNumOfApps = this.getAutoIncrementedNumOfApps.bind(this);
    this.addLink = this.addLink.bind(this);
    // this.checkIfCanDeleteApp = this.checkIfCanDeleteApp.bind(this);
  }


  componentDidMount() {

  }

  generateNotifications(item) {
    return (
      <div className="col-md-12">
        <Notification type={item.type} >{item.content}</Notification>
      </div>
    )
  }
  savetoreduxandfirebase() {
    var data = this.processdataforfirebase(this.state.treeData);
    firebase.app.database().ref('myapps/' + this.props.params.sub + "/venues").set(data);
    this.props.updateobjectwithtracks({ eventkey: this.props.params.sub, type: 'venues', data: data });
  }

  doDelete(treeData) {
    console.log("Do delete ");
    console.log(treeData);
    console.log("Item to delete: " + this.state.pathToDelete);
    var data = treeData;
    var path = this.state.pathToDelete;


    //data= [{ tree_path: 0 },{ tree_path: 1 }];

    console.log(data);
    console.log(path);

    var nodes = removeNodeAtPath({
      treeData: data,
      path: path,
      getNodeKey: ({ node }) => node.key,
    })

    this.setState({
      treeData: nodes
    }, () => {
      console.log("DOne");
      console.log(this.state.treeData);
      this.savetoreduxandfirebase();
    });
    // this.processDataForSaving(nodes);
    this.refs.deleteDialog.hide()
  }


  cancelDelete() {
    console.log("Cancel Delete");
    this.refs.deleteDialog.hide()
  }

  getSlug() {
    var lastIndex = Config.appEditPath.lastIndexOf("/");
    lastIndex++;
    var slug = Config.appEditPath.substring(lastIndex);
    return slug;
  }


  appendSection(sectionName, icon, treeData) {
    // console.log("In addnew section");
    if (components != null) {
      var selectedSection = null;
      console.log("check here3");
      console.log(components);
      var componenetsdata = components.navigation.menus;
      for (let index = 0; index < componenetsdata.length; index++) {
        const element = componenetsdata[index];
        if (element.name.toLowerCase() == sectionName.toLowerCase()) {
          selectedSection = element;
        }
      }

      if (selectedSection != null) {
        //alert(selectedSection);
        var treeData = treeData;
        var slug = this.getSlug();



        //Convert to json 
        var jsRepr = JSON.stringify(selectedSection);
        //console.log(jsRepr);
        var find = 'data_point\":\"';
        var re = new RegExp(find, 'g');
        jsRepr = jsRepr.replace(re, 'data_point\":\"' + slug + '_');
        selectedSection = JSON.parse(jsRepr);
        // console.log(jsRepr);

        // console.log(treeData);
        // console.log(selectedSection);
        treeData.push(selectedSection);
        this.props.addnewsection(treeData, this.props.params.sub);

        //console.log(treeData);
        this.saveNewMenuStructure(treeData);
        window.getReactInterfaceToJS().showNotification('bottom', 'right', 'success', "The new component <b>" + sectionName + "</b> has been added. Check it in the sections panel.", icon);
      } else {
        window.getReactInterfaceToJS().showNotification('bottom', 'right', 'warning', "We couldn't find the required component <b>" + sectionName + "</b>. Make sure you have updated the demo data in firebase.", icon);
      }
    } else {
      window.getReactInterfaceToJS().showNotification('bottom', 'right', 'danger', "Components not fetched. Pls check install manual.", icon);
    }
  }

  saveNewMenuStructure(menus) {
    firebase.app.database().ref(Config.appEditPath + '/navigation/menus').set(menus);
  }

  saveAppInfo(key, value) {
    var update = {};
    update[key] = value;
    this.setState(update);
    firebase.app.database().ref(Config.appEditPath + '/' + key).set(value);
    firebase.app.database().ref(Config.appEditPath + '/appIsSubmited').set(null);
  }


  /**
   * Saving extra sync app info
   * @param {String} value 
   * @param {String} type  shopify | wordpress
   * @param {int} rabid the id of the app
   */
  saveSyncAppInfo(value, type, rabid) {
    var objectToSave = {};
    var path = "saasraab/"
    var slug = this.getSlug();
    if (type == "shopify") {
      path += "shopifySites";
      objectToSave.firestoreCollectionForCategories = slug + "_product_collection_shopify"
      objectToSave.firestoreCollectionForProduct = slug + "_products_shopify";
      objectToSave.shopifySite = value;
    } else if (type == "wordpress") {
      path += "wordpressSites";
      objectToSave.wordpressSite = value;
    }
    path += "/" + rabid;
    firebase.app.database().ref(path).set(objectToSave);
  }

  getObjectDiff(obj1, obj2) {
    const diff = Object.keys(obj1).reduce((result, key) => {
      if (!obj2.hasOwnProperty(key)) {
        result.push(key);
      } else if (_.isEqual(obj1[key], obj2[key])) {
        const resultKeyIndex = result.indexOf(key);
        result.splice(resultKeyIndex, 1);
      }
      return result;
    }, Object.keys(obj2));

    return diff;
  }
  processdataforfirebase(data) {
    var tracks = {};
    var infobooths = {};
    for (let index = 0; index < data.length; index++) {
      tracks[data[index].key] = {
        name: data[index].title,
        o: index
      }
      if (data[index].children) {
        for (let j = 0; j < data[index].children.length; j++) {
          var d = data[index].children[j];
          var infobooth = {};
          infobooth.name = d.title;
          infobooth.o = j;
          infobooth.des = d.des ? d.des : null;
          infobooth.pin = d.pin ? d.pin : null;
          infobooth.state = d.state ? d.state : null;
          infobooth.city = d.city ? d.city : null;
          infobooth.state = d.state ? d.state : null;
          infobooth.country = d.country ? d.country : null;
          infobooth.lat = d.lat ? d.lat : null;
          infobooth.long = d.long ? d.long : null;
          infobooth.phone = d.phone ? d.phone : null;
          infobooth.email = d.email ? d.email : null;
          infobooth.phone = d.phone ? d.phone : null;
          infobooth.add = d.add ? d.add : null;
          infobooth.website = d.website ? d.website : null;
          infobooth.track = data[index].key;
          infobooths[d.key] = infobooth;
        }
      }
    }
    return { tracks: tracks, venue: infobooths };
  }
  processDataForSaving(treeData) {
    var data = JSON.parse(JSON.stringify(treeData));
    var olddata = this.processdataforfirebase(this.state.treeData);
    var newdata = this.processdataforfirebase(data);
    if (_.isEqual(olddata, newdata)) {
      console.log("Do not save");
      this.setState({
        treeData
      });
    } else {
      console.log("Save data");
      data.map((d) => {
        if (d.children) {
          d.children.map(child => {
            child["track"] = d.key
          })
        }
      })
      console.log(newdata);
      this.setState({
        treeData: data
      }, () => {
        this.savetoreduxandfirebase();
      });
    }


    // this.setState({ treeData })

    // console.log(tosavedata);
    // this.saveNewMenuStructure(data);
    // this.props.addnewsection(treeData, this.props.params.sub);

  }

  createButton(item, theClass, treeData) {
    return <button onClick={() => {
      this.appendSection(item.componentName, item.icon, treeData);
    }} className={"btn " + theClass}><i className="material-icons">{item.icon}</i>{item.name}</button>
  }

  generateIndex(index) {
    var expandedCount = 0;
    this.state.treeData.forEach(element => {
      if (element.expanded && element.subMenus && element.subMenus.length > 0) {
        expandedCount++;
      }
    });
    return expandedCount;
  }

  formIt(path) {
    if ((path + "").indexOf(',') == -1) {
      return path;
    } else {
      return (path + "").substring((path + "").indexOf(',') + 1);
    }
  }



  refreshDataAndHideNotification(time = 3000) {
    //Hide notifications
    setTimeout(function () { this.setState({ notifications: [] }) }.bind(this), time);
  }

  addLink(theNode, path) {
    console.log("Do add link ");
    console.log("Item to insert in: " + path);
    var data = this.state.treeData;



    //data= [{ tree_path: 0 },{ tree_path: 1 }];

    console.log(data);
    console.log(path);

    var nodes = addNodeUnderParent({
      treeData: data,
      newNode: {
        image: "https://cdn2.iconfinder.com/data/icons/essential-web-5/50/placeholder-dash-dot-disapear-frame-512.png",
        link: "http://example.com",
        name: "Link Name",
        title: "Link Name",
        id: theNode.subMenus.length + 1,
      },
      parentKey: theNode.tree_path,
      getNodeKey: ({ node }) => node.key,
    }).treeData;

    console.log(nodes);


    this.setState({
      treeData: nodes
    })

    this.processDataForSaving(nodes);
  }

  sectionTabContent(treeData) {
    var data = JSON.parse(JSON.stringify(treeData))
    return (
      <div style={{ height: 400 }}>

        <SortableTree
          ref="sortableTree"
          maxDepth={2}
          // isVirtualized={false}
          treeData={this.state.treeData}
          canNodeHaveChildren={(item) => {
            if (item.track) {
              return false;
            } else {
              return true;
            }
          }}
          // onChange={treeData => this.setState({ treeData })}

          onChange={treeData => this.processDataForSaving(treeData)}
          getNodeKey={getNodeKey}
          generateNodeProps={({ node, path }) => ({

            buttons: [
              <button className="btn-primary" onClick={() => {
                console.log("Clicked");
                console.log(node);
                console.log(path);
                if (path.length == 1) {
                  console.log("For tracks");
                  console.log(node.title);
                  this.setState({
                    sectionsactive: ["", "active", ""],
                    trackname: node.title,
                    updatetrack: true,
                    selectedtrackname: node.title,
                    selectedtrack: node
                  })
                } else {
                  console.log("For infobooths");
                  console.log(node.title);
                  this.setState({
                    sectionsactive: ["", "", "active"],
                    infoboothname: node.title,
                    updateinfobooth: true,
                    selectedinfoboothname: node.title,
                    selectedinfobooth: node,
                    trackvalue: node.track,
                    infoboothdes: node.des,
                    infoboothlat: node.lat,
                    infoboothstate: node.state,
                    infoboothlong: node.long,
                    infoboothadd: node.add,
                    infoboothcity: node.city,
                    infoboothpin: node.pin,
                    infoboothcountry: node.country,
                    infoboothemail: node.email,
                    infoboothphone: node.phone,
                    infoboothwebsite: node.website,
                  })
                }
              }}>
                <i className="material-icons">edit</i>
              </button>,
              <div>
                &nbsp;&nbsp;
                <a onClick={() => {
                  this.refs.deleteDialog.show();
                  console.log("Delete");
                  this.setState({ nodeToDelete: node, pathToDelete: path })
                }} >
                  <button className="btn-danger">
                    <i className="material-icons">delete</i>
                  </button></a>
              </div>,
            ],
          })}


        />
      </div>)
  }


  addNewSectionContent(treeData) {
    // console.log("in add new section");
    // console.log(treeData);
    return (<div>

      {/* <button onClick={()=>{this.setState({showAddButton:!this.state.showAddButton})}} className="btn btn-rose"><i className={!this.state.showAddButton?"fa fa-window-restore":"fa fa-minus"}></i> {!this.state.showAddButton?"Add Master detail":"Cancel adding Master detail"}</button> */}
      <div>

        <hr />
        {T.td("MASTER DETAILS VIEWS")}
        <br />
        {this.state.md.map((item) => {
          return this.createButton(item, Config.designSettings.submitButtonClass, treeData);
        })}
        <hr />

      </div>
      <div>

        <hr />
        {T.td("SPECIFIC VIEWS")}
        <br />

        {this.state.sv.map((item) => {
          return this.createButton(item, Config.designSettings.buttonSuccessClass, treeData);
        })}
        <hr />
        <br />
      </div>
    </div>)
  }

  confirmDeleteApp() {
    if (this.state.inputDelete.length > 0 && this.state.inputDelete === "delete") {
      firebase.app.database().ref(Config.appEditPath).remove();
      this.getAutoIncrementedNumOfApps();
      window.location = "#"
    } else alert(T.ts("Please write delete to confirm deleting the app"))
  }

  // checkIfCanDeleteApp(rabId) {
  //   var _this = this;
  //   var rab_pointers = firebase.app.database().ref("rab_pointers/apps_queue/" + rabId + "_both");
  //   rab_pointers.on('value', function (snapshot) {
  //     _this.setState({
  //       canDeleteApp: snapshot.val() ? false : true
  //     })
  //   });
  // }

  getAutoIncrementedNumOfApps() {
    var num_of_apps_ai = firebase.app.database().ref('/users/' + firebase.app.auth().currentUser.uid + '/numOfApps');
    num_of_apps_ai.transaction(function (ai) {
      if (ai) {
        ai--;
      }
      return ai;
    }, function (e, done, ai) {
      firebase.app.database().ref('/users/' + firebase.app.auth().currentUser.uid).update({
        numOfApps: ai.val()
      });
    });
  }
  wizzardsectionchange = () => {
    console.log("Section changed");
    this.setState({
      trackname: "",
      selectedtrack: {},
      selectedtrackname: '',
      updatetrack: false,
      updateinfobooth: false,
      selectedinfobooth: {},
      selectedinfoboothname: "",
      trackvalue: '',
      infoboothname: '',
      infoboothdes: '',
      infoboothlat: "",
      infoboothlong: "",
      infoboothstate: "",
      infoboothadd: "",
      infoboothcity: "",
      infoboothpin: "",
      infoboothcountry: "",
      infoboothemail: "",
      infoboothphone: "",
      infoboothwebsite: "",
    })
  }


  basicInfoContent() {

    return (
      <div>
        <br />
        <div className="input-group">
          <span className="input-group-addon">
            <i className="material-icons">border_color</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("Track name")}</label>
            <input value={this.state.trackname} name="name" onChange={(event) => {
              this.setState({ trackname: event.target.value })
            }} type="text" className="form-control" />
          </div>
        </div>
        <br />
        <div className="col-md-6 col-md-offset-3">
          <button type="button" onClick={() => {
            if (this.state.updatetrack) {
              console.log("Updating Track");

              console.log(this.state.trackname);
              console.log(this.state.selectedtrack);
              var nameoftrack = this.state.trackname;
              var keyoftrack = this.state.selectedtrack.key;
              this.setState((prevState) => {
                return {
                  treeData: prevState.treeData.map(
                    (content, i) => i === this.state.selectedtrack.o ? { ...content, title: this.state.trackname }
                      : content
                  ),
                  trackname: "",
                  updatetrack: false,
                  selectedtrackname: '',
                  selectedtrack: {},
                  sectionsactive: ["active", "", ""]
                }
              }, () => {
                firebase.app.database().ref("myapps/" + this.props.params.sub + "/venues/tracks/" + keyoftrack + "/name").set(nameoftrack).then(() => {
                  console.log("Updated");
                }).catch(err => {
                  console.log(err);
                })
                this.props.updateobjectwithtracks({ eventkey: this.props.params.sub, type: 'venues', data: this.processdataforfirebase(this.state.treeData) });
                window.getReactInterfaceToJS().showNotification('bottom', 'right', 'success', "The track <b>" + nameoftrack + "</b> has been updated.");

              });

            } else {
              console.log("Adding new track");
              console.log(this.state.trackname);
              var firebaseref = firebase.app.database().ref('myapps/' + this.props.params.sub + "/venues/tracks").push();
              var key = firebaseref.key;
              console.log(key);
              var treedata = this.state.treeData;
              firebaseref.set({
                name: this.state.trackname,
                o: treedata.length
              })
              var nameoftrack = this.state.trackname;
              this.setState((prevState) => {
                return {
                  treeData: [...prevState.treeData, {
                    key: key,
                    title: this.state.trackname,
                    expanded: true,
                    o: treedata.length

                  }],
                  trackname: ""
                }
              }, () => {
                this.props.updateobjectwithtracks({ eventkey: this.props.params.sub, type: 'venues', data: this.processdataforfirebase(this.state.treeData) });
                window.getReactInterfaceToJS().showNotification('bottom', 'right', 'success', "The new track <b>" + nameoftrack + "</b> has been added. Check it in the tracks panel.");
              });
            }
          }} className="btn btn-primary" disabled={this.state.updatetrack ? (this.state.trackname == this.state.selectedtrackname) : !this.state.trackname}>{T.td(this.state.updatetrack ? "Update Track" : "Add Track")}</button>
        </div>

      </div>)
  }


  imagesContent() {

    return (
      <div className="center col-md-12 ml-auto mr-auto">
        <div className="input-group">
          <span className="input-group-addon">
            <i className="material-icons">border_color</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("Venue name")}</label>
            <input value={this.state.infoboothname} name="name" onChange={(event) => {
              this.setState({ infoboothname: event.target.value })
            }} type="text" className="form-control" />
          </div>
          <span className="input-group-addon">
            <i className="material-icons">border_color</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("Address")}</label>
            <input value={this.state.infoboothadd} name="name" onChange={(event) => {
              this.setState({ infoboothadd: event.target.value })
            }} type="text" className="form-control" />
          </div>
          <span className="input-group-addon">
            <i className="material-icons">location_on</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("Latitude")}</label>
            <input value={this.state.infobothlat} name="name" onChange={(event) => {
              this.setState({ infoboothlat: event.target.value })
            }} type="text" className="form-control" />
          </div>
          <span className="input-group-addon">
            <i className="material-icons">location_on</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("Longitude")}</label>
            <input value={this.state.infoboothlong} name="name" onChange={(event) => {
              this.setState({ infoboothlong: event.target.value })
            }} type="text" className="form-control" />
          </div>
        </div>
        <div className="input-group">
          <span className="input-group-addon">
            <i className="material-icons">location_city</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("City")}</label>
            <input value={this.state.infoboothcity} name="name" onChange={(event) => {
              this.setState({ infoboothcity: event.target.value })
            }} type="text" className="form-control" />
          </div>
          <span className="input-group-addon">
            <i className="material-icons">location_city</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("State")}</label>
            <input value={this.state.infoboothstate} name="name" onChange={(event) => {
              this.setState({ infoboothstate: event.target.value })
            }} type="text" className="form-control" />
          </div>
          <span className="input-group-addon">
            <i className="material-icons">location_city</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("Country")}</label>
            <input value={this.state.infoboothcountry} name="name" onChange={(event) => {
              this.setState({ infoboothcountry: event.target.value })
            }} type="text" className="form-control" />
          </div>
          <span className="input-group-addon">
            <i className="material-icons">location_city</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("Pin")}</label>
            <input value={this.state.infoboothpin} name="name" onChange={(event) => {
              this.setState({ infoboothpin: event.target.value })
            }} type="text" className="form-control" />
          </div>
        </div>
        <div className="input-group">
          <span className="input-group-addon">
            <i className="material-icons">email</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("Email")}</label>
            <input value={this.state.infoboothemail} name="name" onChange={(event) => {
              this.setState({ infoboothemail: event.target.value })
            }} type="text" className="form-control" />
          </div>
          <span className="input-group-addon">
            <i className="material-icons">phone</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("Phone")}</label>
            <input value={this.state.infoboothphone} name="name" onChange={(event) => {
              this.setState({ infoboothphone: event.target.value })
            }} type="text" className="form-control" />
          </div>
          <span className="input-group-addon">
            <i className="material-icons">web</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("Website")}</label>
            <input value={this.state.infoboothwebsite} name="name" onChange={(event) => {
              this.setState({ infoboothwebsite: event.target.value })
            }} type="text" className="form-control" />
          </div>
        </div>
        <br />
        <label>{T.td("Track name")}</label>

        <div className="form-group">
          <select className="form-control" value={this.state.trackvalue} onChange={(event) => {
            this.setState({ trackvalue: event.target.value });

          }}>
            <option disabled hidden value=''></option>
            {this.state.treeData.map(item => {
              return (
                <option value={item.key} key={item.key}>{item.title}</option>

              )
            })}

          </select>
        </div>

        <br />
        <div className="form-group">
          <label>{T.td("Description")}</label>


          <HTML theKey={"htmlkey"} value={this.state.infoboothdes} updateAction={(data) => {
            this.setState({
              infoboothdes: data
            })
          }}></HTML>

        </div>
        <div className="col-md-6 col-md-offset-3">
          <button type="button"
            onClick={() => {
              console.log("infobooth clicked");
              console.log(this.state.infoboothname);
              console.log(this.state.trackvalue);
              console.log(this.state.infoboothdes);
              if (this.state.updateinfobooth) {
                console.log("Updating infobooth");
                var nameofinfobooth = this.state.infoboothname;

                var newtreedata = JSON.parse(JSON.stringify(this.state.treeData));
                console.log(this.state.selectedinfobooth);
                if (this.state.trackvalue == this.state.selectedinfobooth.track) {
                  newtreedata.map(content => {
                    if (content.key == this.state.trackvalue) {
                      content.children.map(child => {
                        if (child.key == this.state.selectedinfobooth.key) {
                          child["name"] = this.state.infoboothname;
                          child["title"] = this.state.infoboothname;
                          child["des"] = this.state.infoboothdes;
                          child["lat"] = this.state.infoboothlat;
                          child["long"] = this.state.infoboothlong;
                          child["add"] = this.state.infoboothadd;
                          child["city"] = this.state.infoboothcity;
                          child["pin"] = this.state.infoboothpin;
                          child["country"] = this.state.infoboothcountry;
                          child["email"] = this.state.infoboothemail;
                          child["phone"] = this.state.infoboothphone;
                          child["website"] = this.state.infoboothwebsite;
                          child["state"] = this.state.infoboothstate;
                          child["track"] = this.state.trackvalue;
                        }
                      })
                    }
                  })
                } else {
                  newtreedata.map(content => {
                    if (content.key == this.state.selectedinfobooth.track) {
                      var children = [];
                      if (content.children) {
                        content.children.map(ch => {
                          console.log(ch.key);
                          console.log(this.state.selectedinfobooth.key);
                          if (ch.key == this.state.selectedinfobooth.key) {
                            console.log("equal")
                          } else {
                            console.log("not equal");
                            children.push(ch);
                          }
                        })
                      }
                      console.log("Here1");
                      console.log(content.children);
                      console.log(children);
                      content.children = children;
                    }
                    if (content.key == this.state.trackvalue) {
                      if (content.children) {
                        var o = content.children.length;
                        content.children.push({
                          lat: this.state.infoboothlat,
                          long: this.state.infoboothlong,
                          add: this.state.infoboothadd,
                          city: this.state.infoboothcity,
                          pin: this.state.infoboothpin,
                          country: this.state.infoboothcountry,
                          email: this.state.infoboothemail,
                          phone: this.state.infoboothphone,
                          website: this.state.infoboothwebsite,
                          des: this.state.infoboothdes,
                          state: this.state.infoboothstate,
                          expanded: true,
                          key: this.state.selectedinfobooth.key,
                          name: this.state.infoboothname,
                          o: o,
                          title: this.state.infoboothname,
                          track: this.state.trackvalue,
                        })
                      } else {
                        content.children = [{
                          lat: this.state.infoboothlat,
                          long: this.state.infoboothlong,
                          add: this.state.infoboothadd,
                          city: this.state.infoboothcity,
                          pin: this.state.infoboothpin,
                          country: this.state.infoboothcountry,
                          email: this.state.infoboothemail,
                          phone: this.state.infoboothphone,
                          website: this.state.infoboothwebsite,
                          state: this.state.infoboothstate,
                          des: this.state.infoboothdes,
                          expanded: true,
                          key: this.state.selectedinfobooth.key,
                          name: this.state.infoboothname,
                          o: 0,
                          title: this.state.infoboothname,
                          track: this.state.trackvalue,
                        }]
                      }

                    }
                  })

                }
                console.log(newtreedata);
                this.setState({
                  treeData: newtreedata,
                  infoboothname: "",
                  infoboothdes: '',
                  infoboothlat: "",
                  infoboothlong: "",
                  infoboothadd: "",
                  infoboothcity: "",
                  infoboothpin: "",
                  infoboothcountry: "",
                  infoboothemail: "",
                  infoboothphone: "",
                  infoboothwebsite: "",
                  infoboothstate: "",

                  selectedtrack: '',
                  selectedinfoboothname: '',
                  selectedinfobooth: {},
                  sectionsactive: ["active", "", ""],
                  updateinfobooth: false
                }
                  , () => {
                    this.savetoreduxandfirebase();
                    window.getReactInterfaceToJS().showNotification('bottom', 'right', 'success', "The infobooth <b>" + nameofinfobooth + "</b> has been updated.");
                  });

              } else {
                console.log("Adding new track");
                var firebaseref = firebase.app.database().ref('myapps/' + this.props.params.sub + "/venues/venue").push();
                var key = firebaseref.key;
                console.log(key);
                var childlength = 0;
                var nameofinfobooth = this.state.infoboothname;
                this.state.treeData.map(item => {
                  if (item.key == this.state.trackvalue) {
                    if (item.children) {
                      childlength = item.children.length;
                    }
                  }
                })
                var newtreedata = this.state.treeData.map(
                  (content, i) => content.key === this.state.trackvalue ? {
                    ...content,
                    children: [
                      ...(content.children ? content.children : []), {
                        key: key,
                        title: this.state.infoboothname,
                        name: this.state.infoboothname,
                        track: this.state.trackvalue,
                        expanded: true,
                        o: childlength,
                        des: this.state.infoboothdes,
                        lat: this.state.infoboothlat,
                        long: this.state.infoboothlong,
                        add: this.state.infoboothadd,
                        city: this.state.infoboothcity,
                        state: this.state.infoboothstate,
                        pin: this.state.infoboothpin,
                        country: this.state.infoboothcountry,
                        email: this.state.infoboothemail,
                        phone: this.state.infoboothphone,
                        website: this.state.infoboothwebsite,
                      }
                    ]
                  }
                    : content
                );
                console.log(newtreedata);
                firebaseref.set({
                  name: this.state.infoboothname,
                  o: childlength,
                  track: this.state.trackvalue,
                  des: this.state.infoboothdes,
                  lat: this.state.infoboothlat,
                  long: this.state.infoboothlong,
                  add: this.state.infoboothadd,
                  city: this.state.infoboothcity,
                  pin: this.state.infoboothpin,
                  state: this.state.infoboothstate,
                  country: this.state.infoboothcountry,
                  email: this.state.infoboothemail,
                  phone: this.state.infoboothphone,
                  website: this.state.infoboothwebsite,
                })
                this.setState({
                  treeData: newtreedata,
                  infoboothdes: '',
                  infoboothlat: "",
                  infoboothlong: "",
                  infoboothadd: "",
                  infoboothcity: "",
                  infoboothpin: "",
                  infoboothcountry: "",
                  infoboothstate: "",
                  infoboothemail: "",
                  infoboothphone: "",
                  infoboothwebsite: "",
                  trackvalue: '',
                  infoboothname: '',
                }
                  , () => {
                    this.props.updateobjectwithtracks({ eventkey: this.props.params.sub, type: 'venues', data: this.processdataforfirebase(this.state.treeData) });
                    window.getReactInterfaceToJS().showNotification('bottom', 'right', 'success', "The new venue <b>" + nameofinfobooth + "</b> has been added. Check it in the tracks panel.");
                  });
              }

            }}
            className="btn btn-primary"
            disabled={this.state.updateinfobooth ? ((this.state.infoboothname == this.state.selectedinfoboothname) && (this.state.trackvalue == this.state.selectedinfobooth.track)
              && (this.state.infoboothlat == this.state.selectedinfobooth.lat)
              && (this.state.infoboothlong == this.state.selectedinfobooth.long)
              && (this.state.infoboothadd == this.state.selectedinfobooth.add)
              && (this.state.infoboothcity == this.state.selectedinfobooth.city)
              && (this.state.infoboothstate == this.state.selectedinfobooth.state)
              && (this.state.infoboothcountry == this.state.selectedinfobooth.country)
              && (this.state.infoboothemail == this.state.selectedinfobooth.email)
              && (this.state.infoboothphone == this.state.selectedinfobooth.phone)
              && (this.state.infoboothwebsite == this.state.selectedinfobooth.website)
              && (this.state.infoboothpin == this.state.selectedinfobooth.pin)
              && (this.state.infoboothdes == this.state.selectedinfobooth.des) || !(this.state.infoboothname && this.state.trackvalue)) : !(this.state.infoboothname && this.state.trackvalue)}>
            {T.td(this.state.updateinfobooth ? "Update Venue" : "Add Venue")}</button>
        </div>
      </div >

    )

  }

  componentWillMount() {
    var infoboothdata = {};
    var categoriestest = [];
    var categories = [];
    if (this.props.events[this.props.params.sub]) {
      if (this.props.events[this.props.params.sub].venues) {
        infoboothdata = JSON.parse(JSON.stringify(this.props.events[this.props.params.sub].venues));
        console.log(infoboothdata);
        var tracks = infoboothdata.tracks ? infoboothdata.tracks : {};
        var infobooths = infoboothdata.venue ? infoboothdata.venue : {};
        Object.keys(infobooths).map((infobooth) => {
          var d = infobooths[infobooth];
          d["key"] = infobooth;
          d["title"] = d.name;
          d["expanded"] = true;
          if ("children" in tracks[d.track]) {
            tracks[d.track].children.push(d);
          } else {
            tracks[d.track].children = [d];
          }
        });
        Object.keys(tracks).map(track => {
          var mdata = tracks[track];
          var children = mdata.children ? mdata.children : [];
          var data = {};
          if (children) {
            var sortedchildren = _.sortBy(children, "o");
            data["children"] = sortedchildren;
          }
          data["key"] = track;
          data["o"] = mdata.o;

          data["expanded"] = true;
          data["title"] = mdata.name;
          categoriestest.push(data);
        });
        categories = _.sortBy(categoriestest, "o");
      }
    }
    this.setState({
      treeData: categories
    });
    // console.log(JSON.stringify(categories));

  }
  render() {
    var tracktitle = this.state.updatetrack ? "Update Track" : "Add new Track";

    var theSteps = [
      {
        name: "sections",
        icon: "subject",
        title: T.td("Tracks"),
        active: this.state.sectionsactive[0],
        label1: T.ts("Drag n Drop them Also you can nest them"),
        label2: T.td("Track sections"),
        content: this.sectionTabContent(this.state.treeData)
      },
      {
        name: "sectionsadd",
        icon: "playlist_add",
        title: T.td("Add Track"),
        active: this.state.sectionsactive[1],
        label1: T.ts(tracktitle),
        content: this.basicInfoContent()
      },
      {
        name: "images",
        icon: "collections",
        title: T.td("Add Venues"),
        active: this.state.sectionsactive[2],
        label1: T.td("Add Venues"),
        content: this.imagesContent()
      }



    ];

    return (
      <div>

        <SkyLight hideOnOverlayClicked ref="deleteDialog" title="">
          <span><h3 className="center-block">{T.ts("Delete section")}</h3></span>
          <div className="col-md-12">
            <Notification type="danger" >{T.ts("All data at this location incuding nested sections will be deleted")}!</Notification>
          </div>
          <div className="col-md-12">
            {T.td("Section name")}
          </div>
          <div className="col-md-12">
            <b>{this.state.nodeToDelete.name}</b>
          </div>

          <div className="col-sm-12" style={{ marginTop: 80 }}>
            <div className="col-sm-6">
            </div>
            <div className="col-sm-3 center-block">
              <a onClick={this.cancelDelete} className="btn btn-info center-block">{T.td("Cancel")}</a>
            </div>
            <div className="col-sm-3 center-block">
              <a onClick={() => this.doDelete(this.state.treeData)} className="btn btn-danger center-block">{T.td("Delete")}</a>
            </div>

          </div>

        </SkyLight>

        <div className="main-panel col-md-12">
          <NavBar currentLangData={this.props.route.currentLangData}></NavBar>

          <Wizzard
            title={"Venues"}
            steps={theSteps}
            stepsActivity={this.state.sectionsactive}
            wizzardsectionchange={this.wizzardsectionchange}
          />
        </div>
      </div>)

  }
}

const mapStateToProps = state => ({
  events: state.eventmodel.mainappdata.events
})

const mapDispatchToProps = dispatch => ({
  addnewsection: dispatch.eventmodel.addnewsection,
  updateobjectwithtracks: dispatch.eventmodel.updateobjectwithtracks
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Venue);


// WEBPACK FOOTER //
// ./src/containers/Builder/venue.js